module.exports = __webpack_public_path__ + "files/ab5335587b320d1a0420351a021f1ac2.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/nature-4.png
// module id = 1464
// module chunks = 60